export const BACKEND_URL = "https://speckit.agiledynamics.de/api/";
export const WEBSOCKET_URL = "wss://speckit.agiledynamics.de/api/ws/";
